import { create } from 'zustand';
import { devtools } from 'zustand/middleware';
import { AuthService } from '../services/auth/AuthService';

type AuthStatus = 'checking' | 'authenticated' | 'unauthenticated';

interface AuthState {
  status: AuthStatus;
  username: string | null;
  setAuthenticated: (username: string) => void;
  logout: () => void;
  checkAuth: () => Promise<void>;
}

export const useAuthStore = create<AuthState>()(
  devtools(
    (set) => ({
      status: 'checking',
      username: null,

      setAuthenticated: (username) =>
        set({ status: 'authenticated', username }),

      logout: () => {
        AuthService.clearToken();
        set({ status: 'unauthenticated', username: null });
      },

      checkAuth: async () => {
        set({ status: 'checking' });
        const valid = await AuthService.validateToken();
        set({ status: valid ? 'authenticated' : 'unauthenticated' });
      },
    }),
    { name: 'auth-store' }
  )
);
